/**
 * Admin notifications feed (`/notifications`).
 * List queries use appendListParams / toQuerySuffix.
 */
import Api from "@/api/Api";
import { appendListParams, toQuerySuffix } from "@/api/buildQueryString";

export default {
  getNotifications(page, pageSize) {
    var params = {};
    appendListParams(params, page, pageSize);
    params = toQuerySuffix(params);
    return Api().get('/notifications' + params);
  },
};
